export default __webpack_public_path__ + "static/media/music_open.eb03a2a2.svg";